import React, {useRef, useEffect, useCallback } from 'react'
import "./audio.css"
import { memo } from "react";

const Audio = (props) => {

  const AudioSource = props.AudioURL;
  const elementRef = useRef(null);
  const handleEvent = useCallback((event) => {
    // use a switch/case to check for each event
    // console.log(`${event.type}\n`);
    if (event.type === 'canplay') {
      //console.log("music can play");
      elementRef.current.volume="0.1"
    }
    if (event.type === 'ended') {
     
    
      if(props.updateAudioStatue){
        props.updateAudioStatue(event.type, elementRef.current.getElementsByTagName("source")[0].src);
      }
    
     
    }
  },[props,elementRef]);

  const playAudio = (newSrc) => {
    
    elementRef.current.src = newSrc;
    elementRef.current.loop = false;
    elementRef.current.play();
  }

  useEffect(() => {
    if(props.playAudio){
      props.playAudio.current = playAudio;
    }
  });
 
 
  useEffect(() => {

    // elementRef.addEventListener('loadstart', handleEvent);
    // elementRef.addEventListener('progress', handleEvent);
    // elementRef.addEventListener('canplay', handleEvent);
    // elementRef.addEventListener('canplaythrough', handleEvent);
    // elementRef.addEventListener('ended', handleEvent);
    // elementRef.addEventListener('pause', handleEvent);
    // elementRef.addEventListener('play', handleEvent);
    // elementRef.addEventListener('playing', handleEvent);
    // elementRef.addEventListener('ratechange', handleEvent);
    // elementRef.addEventListener('seeking', handleEvent);
    // elementRef.addEventListener('stalled', handleEvent);

    ['loadstart', 'ended', 'canplay', 'playing', 'pause' /* all the other events */].forEach(event =>
      elementRef.current.addEventListener(event, handleEvent)
    )
   
    return () => {/* remove all event listeners here */ }
  }, [elementRef, handleEvent]);

  return (
    <div className="Audio">
      <audio autoPlay={true} loop={true} ref={elementRef}>
        <source src={AudioSource} type="audio/mp3" />
      </audio>
    </div>
  );
}

export default memo(Audio);